module.exports = __webpack_public_path__ + "static/media/drpaystub.c40fbc16.png";